/** Resolve o variant visual a partir do packageType do tenant (ADR-126).
 *  team+professional colapsam em team-pro (decisão Tech Lead — 3 variants).
 *  null/desconhecido → solo (mais restritivo, fail-safe). */
export function resolveVariant(packageType) {
    switch (packageType) {
        case 'regulated':
            return 'regulated';
        case 'team':
        case 'professional':
            return 'team-pro';
        case 'solo':
            return 'solo';
        default:
            return 'solo';
    }
}
//# sourceMappingURL=variant.js.map